'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var NewPooledSeasonalityCalendarController = function NewPooledSeasonalityCalendarController($scope, $log, commonUiConstants, seasonalityConstants, specialEventsService, newCalendarService, gridDropdownPopulateService, retrieverConstants, dataRetrieverService) {
  $scope.seasonalityNameRegex = commonUiConstants.SEASONALITY_NAME_REGEX;
  $scope.specialEventsGridId = seasonalityConstants.SPECIAL_EVENTS_NEW_CALENDAR_GRID_ID;
  $scope.submitted = false;
  $scope.isDuplicateCalendar = false;
  $scope.isPooledDemandCalendar = true;
  $scope.initUiDates = function () {
    $scope.maxDateTo = $scope.calendar.dateRangeTo;
    $scope.maxDateFrom = $scope.calendar.dateRangeFrom;
    $scope.uiDateRangeTo = $scope.calendar.dateRangeTo;
    $scope.uiDateRangeFrom = $scope.calendar.dateRangeFrom;
  };
  $scope.initNewCalendarModel = function () {
    $scope.calendar.markets = _.map($scope.marketList, 'value');
  };
  $scope.initCopyCalendarModel = function () {
    $scope.calendar.name = $scope.calendar.name + ' Copy';
  };
  $scope.initSelectedMarkets = function () {
    $scope.calendar.selectedMarkets = _.map($scope.calendar.markets, function (market) {
      return {
        market: market,
        selected: true
      };
    });
  };
  $scope.initMarketsForSpecialEvents = function () {
    var specialEventMarkets = validateCalendarList($scope.calendar) ? $scope.calendar.markets : [];
    gridDropdownPopulateService.setSpecialEventMarkets(specialEventMarkets);
  };
  $scope.initModel = function () {
    $scope.initUiDates();
    $scope.regressionsTermsList = seasonalityConstants.REGRESSION_TERMS;
    $scope.learningProcesslist = seasonalityConstants.LEARNING_PROCESSES;
    if (_.isEmpty($scope.calendar.name)) {
      $scope.initNewCalendarModel();
    } else {
      $scope.initCopyCalendarModel();
    }
  };
  $scope.initModel();
  function showEventsError(msg) {
    $log.error('NewPooledSeasonalityCalendarController: showSubmitCalendarModal - ' + msg);
    toastr.error(msg);
    return false;
  }
  $scope.validateSpecialEvents = function () {
    $scope.calendar.eventsForSubmit = specialEventsService.createSpecialEventsRequest($scope.calendar.events);
    var specialEventsCheck = newCalendarService.validateSpecialEvents($scope.calendar.eventsForSubmit);
    if (specialEventsCheck !== '_clear') {
      return showEventsError(specialEventsCheck);
    }
    specialEventsCheck = newCalendarService.validateSpecialEventsDates($scope.calendar.eventsForSubmit);
    if (specialEventsCheck !== '_clear') {
      return showEventsError(specialEventsCheck);
    }
    return true;
  };
  $scope.showSubmitCalendarModal = function () {
    if ($scope.validateSpecialEvents() && validateCalendar($scope.calendar)) {
      $scope.initSelectedMarkets();
      $scope.openSubmitModal();
    }
  };
  function validateOutlier(calendar) {
    return calendar.outlierTolerance && calendar.outlierTolerance >= 0;
  }
  function validateCalendarList(calendar) {
    return !(_.isNil($scope.calendar.markets) && _.isEmpty($scope.calendar.markets));
  }
  function validateCalendar(calendar) {
    return validateOutlier(calendar) && validateCalendarList(calendar);
  }
  $scope.setValidationFlag = function () {
    if (_.isEmpty($scope.calendar)) {
      return;
    }
    $scope.isCalendarValid = validateCalendar($scope.calendar);
  };
  $scope.validateUniqNameAndSubmit = function () {
    $scope.isDuplicateCalendar = false;
    dataRetrieverService.getDataRetriever(retrieverConstants.SEASONALITY_SCREEN, retrieverConstants.SEASONALITY_POOLED_MODE).retrieveComponentData('seasonality-pooled-calendars').then(function (data) {
      var filteredExistingCalendar = _.filter(data, function (calendar) {
        return calendar.calendarName === $scope.calendar.name;
      });
      if (filteredExistingCalendar.length > 0) {
        $scope.isDuplicateCalendar = true;
      } else {
        $scope.submitNewCalendar();
      }
    });
  };
  $scope.submitNewCalendar = function () {
    $scope.sendNewCalendarRequest();
  };
  function onRequestSuccess() {
    $scope.submitted = true;
    toastr.success('Your calendar has been successfully submitted.');
  }
  function onRequestFail() {
    $scope.submitted = true;
    $log.error('NewCalendarController: onRequestFail - An error has occurred. Please try again');
    toastr.error('An error has occurred. Please try again.');
  }
  $scope.sendNewCalendarRequest = function () {
    newCalendarService.sendNewCalendarRequest($scope.calendar, $scope.isPooledDemandCalendar).then(onRequestSuccess, onRequestFail)["finally"](function () {
      $scope.closeSubmitModal();
    });
  };
  $scope.$watchGroup(['calendar.learningProcess', 'calendar.regressionTerms', 'calendar.outlierTolerance'], function (newValues, oldValues) {
    if (!_.isEqual(newValues, oldValues)) {
      $scope.setValidationFlag();
    }
  });
  $scope.$watch('calendar.markets', function (newValue, oldValue) {
    if (_.isEqual(newValue, oldValue)) {
      return;
    }
    if (_.isEmpty($scope.calendar)) {
      gridDropdownPopulateService.setSpecialEventMarkets([]);
      return;
    }
    gridDropdownPopulateService.setSpecialEventMarkets($scope.calendar.markets);
    $scope.setValidationFlag();
  });
};
NewPooledSeasonalityCalendarController.$inject = ['$scope', '$log', 'CommonUiConstants', 'SeasonalityConstants', 'SpecialEventsService', 'NewCalendarService', 'GridDropdownPopulateService', 'DataRetrieverConstantsService', 'DataRetrieverService'];
module.exports = NewPooledSeasonalityCalendarController;